import React from "react";
import Icon from "assets/icons";
import FormContainer from "shared/form";
import { CouponCodeViewEnum } from "./enum";
import useCouponCodeService from "./service";
import Button from "shared/components/button";
import { CouponCodePropTypes } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import { FormikProps, FormikValues } from "formik";
import { getCouponCodeDiscountMessage } from "./utils";
import FormTextField from "shared/form/fields/textField";
import SaveCloseButton from "shared/components/button/components/saveCloseButton";

function CouponCode(props: CouponCodePropTypes) {
  const copies = useCopies();
  const service = useCouponCodeService(props);

  if (service.state.applicableView === CouponCodeViewEnum.NONE) return null;

  return (
    <React.Fragment>
      {service.state.applicableView === CouponCodeViewEnum.COUPON_APPLIED && props.purchaseOrderLine && (
        <div className="cpnCodeWrapper">
          <div className="cpnCodeWrapper_cpnCode">
            <div className="cpnCodeWrapper_cpnCodeLabel">
              <Icon.Coupon />
              <span className="cpnCodeWrapper_cpnCodeText" title={props.purchaseOrderLine.couponCode}>
                {props.purchaseOrderLine.couponCode}
              </span>
              <span className="cpnCodeWrapper_cpnCodeAdditionalText">{copies.get("applied")}</span>
            </div>
            <div className="cpnCodeWrapper_cpnCodeDetails">
              <span className="cpnCodeWrapper_cpnCodeDetails--ogPrice">
                <b>{getCouponCodeDiscountMessage(copies, props.purchaseOrderLine)}</b>
              </span>
            </div>
          </div>
          {!props.disableCouponActions && (
            <div className="cpnCodeWrapper_cpnCodeEditDelete">
              <Button.Edit icon={<Icon.EditIcon size={12} />} label="" onClick={service.editClickHandler} />
              <Button.Delete icon={<Icon.Close size={16} />} label="" onClick={service.deleteClickHandler} />
            </div>
          )}
        </div>
      )}

      {service.state.applicableView === CouponCodeViewEnum.COUPON_CODE_INPUT && (
        <div className="cpnCodeWrapper">
          <FormContainer
            initialValues={service.formHelper.initialValues}
            validationSchema={service.formHelper.validationSchema}
            onSubmit={service.applyCouponSubmitHandler}>
            {({ isValid, submitForm }: FormikProps<FormikValues>) => (
              <div className="cpnCodeWrapper_cpnCodeForm">
                <div className="cpnCodeWrapper_cpnCodeFormWrapper">
                  <FormContainer.Form>
                    <FormTextField
                      required
                      fullWidth
                      label=""
                      name="couponCode"
                      icon={<Icon.Coupon />}
                      placeholder={copies.get("coupon.code.at.checkout.field.placeholder")}
                    />
                  </FormContainer.Form>
                </div>
                <div className="cpnCodeWrapper_cpnCodeFormAction">
                  <SaveCloseButton
                    saveDisabled={!isValid}
                    saveHandler={submitForm}
                    closeHandler={service.cancelEditHandler}
                  />
                </div>
              </div>
            )}
          </FormContainer>
        </div>
      )}

      {service.state.applicableView === CouponCodeViewEnum.COUPON_APPLICABLE && (
        <div className="askCouponCode">
          <Icon.Coupon />
          {copies.get("coupon.code.at.checkout.applicable.message")}
          <span>
            <Button.Link
              onClick={() => service.couponCodeViewChangeHandler(CouponCodeViewEnum.COUPON_CODE_INPUT)}
              label={copies.get("coupon.code.at.checkout.applicable.inline.button.label")}
            />
            {copies.get("question.mark")}
          </span>
        </div>
      )}
    </React.Fragment>
  );
}

export default CouponCode;
